import { render, staticRenderFns } from "./LeftTextUnit.vue?vue&type=template&id=16e28a03&scoped=true"
import script from "./LeftTextUnit.vue?vue&type=script&lang=js"
export * from "./LeftTextUnit.vue?vue&type=script&lang=js"
import style0 from "./LeftTextUnit.vue?vue&type=style&index=0&id=16e28a03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e28a03",
  null
  
)

export default component.exports